module.exports = __webpack_public_path__ + "img/iata.f5669a34.webp";